import {
  Component, OnInit, Input, Output, EventEmitter,
  AfterContentInit, ContentChildren, QueryList, OnChanges, SimpleChanges
} from '@angular/core';
import { OnDestroy, AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { LFTabChangeEvent } from './lf-tab-change-event';
import { Subscription } from 'rxjs/Subscription';
import { SearchService } from '../../../search/search.service';
import { SHOW_TAB_EVENT } from '../../../search/search-constants';


@Component({
  selector: 'lfwms-tabbedpane',
  styleUrls: ['./lf-tabbedpane.component.css'],
  template: `
             <div [hidden]="!expanded" class="lf-tabdpane-content" [class.expanded]="expanded">
                <ng-content></ng-content>
              </div>
            `
})
export class LfTabbedpaneComponent implements OnDestroy {
  static counter = 0; // To keep track of tabIndex

  @Input() expanded: boolean;
  @Input() header: string;
  @Input() tabId: string;
  private tabIndex: number;


  constructor() {
    this.tabIndex = LfTabbedpaneComponent.counter++;
    if (!this.tabId) {
      this.tabId = this.tabIndex.toString();
    }
  }

  ngOnDestroy() {
    LfTabbedpaneComponent.counter = 0;
  }

}


@Component({
  selector: 'lfwms-tabbedpanes',
  styleUrls: ['./lf-tabbedpane.component.css'],
  template: `
            <div  class="lf-tabdpanes-wrapper">
              <div class="lf-tabdpanes-header-wrapper">
                <span *ngFor="let tab of tabs"
                (click)="showTab(tab)"
                title="{{tab.header}}"
                class="lf-tabdpane-header"
                [class.expanded]="tab.expanded">
                  {{tab.header}}
                </span>
              </div>
            <ng-content></ng-content>
            </div>
            `
})
export class LfTabbedpanesComponent implements AfterContentInit, OnChanges {

  constructor() { }
  @ContentChildren(LfTabbedpaneComponent) tabs: QueryList<LfTabbedpaneComponent>;
  // emits the selected tab's id or index if id is null
  @Output() openedTabId: EventEmitter<string> = new EventEmitter();
  @Input() public searchService: SearchService;
  public eventSubscription: Subscription;
  // used to check whether we need to do some pretab change validations
  @Output() preTabChanged: EventEmitter<LFTabChangeEvent> = new EventEmitter();
  @Input() selectTabIndex: number;
  public ngOnChanges(changes: SimpleChanges) {
    // This code is added when we need to have new tabs added due to action performed in one tab
    if (this.searchService) {
      this.eventSubscription = this.searchService.receiveEvent().subscribe((event: any) => {
        if (event.type === SHOW_TAB_EVENT) {
          setTimeout(() => {
            if (this.tabs) {
              this.showTab(this.tabs.toArray()[Number(event.selectedItemId)]);
            }
          }, 0);
        }
      });
    }
    if (changes['selectTabIndex']) {

      if (this.tabs
        && changes['selectTabIndex'].currentValue > -1
        && changes['selectTabIndex'].currentValue < this.tabs.toArray().length) {
        this.showTab(this.tabs.toArray()[changes['selectTabIndex'].currentValue]);
      }
    }
  }
  ngAfterContentInit() {
    // open the first tab none of the tab has input expanded=true
    const activeTabs = this.tabs.filter((tab) => tab.expanded);
    if (activeTabs.length === 0) {
      this.showTab(this.tabs.first);
    }

    // else {
    //   this.showTab(activeTabs[0]) ;
    // }
  }


  private showTab(selectedTab: LfTabbedpaneComponent) {
    const tabChangeEvent = new LFTabChangeEvent();
    tabChangeEvent.tabId = selectedTab.tabId;
    tabChangeEvent.hasError = false;
    this.preTabChanged.emit(tabChangeEvent);

    if (!tabChangeEvent.hasError) {
      // unselect all tabs
      this.tabs.toArray().forEach(tab => tab.expanded = false);

      // select the clicked tab.
      selectedTab.expanded = true;
      this.openedTabId.emit(selectedTab.tabId);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/platform/lf-tabbedpane/lf-tabbedpane.component.ts